<template>
  <div class="d-flex flex-column align-center justify-center" style="height: 90vh; padding-left: 25px; padding-right: 25px; margin-top: -10px;">
    <div class="text-center" style="background-color: #fff; padding-top: 40px; width: 100%;">
      <v-typography class="headingHome" variant="display-1">Configurator</v-typography>
    </div>

    <v-box class="d-flex flex-column align-center justify-center"
      style="width: 100%; height: 100%; background-color: #fff; overflow: auto; padding: 1em;">
      <v-row dense>
        <v-col cols="6" class="">
          <v-card class="d-flex align-center justify-center h-100" @click="$router.push('/machines')" >
            <v-card-item class="text-center">
              <v-icon icon="mdi-wrench" style="font-size: 84px;">
              </v-icon>
              <h6 class="text">Machines</h6>
            </v-card-item>
          </v-card>
        </v-col>
        <v-col cols="6" class="">
          <v-card class="d-flex align-center justify-center h-100" @click="$router.push('/logbooks-config')">
            <v-card-item class="text-center">
              <v-icon icon="mdi-table-edit" style="font-size: 84px;">
              </v-icon>
              <h6 class="text">Logbook</h6>
            </v-card-item>
          </v-card>
        </v-col>
        <v-col cols="6" class="">
          <v-card class="d-flex align-center justify-center h-100" @click="$router.push('/logbooks')">
            <v-card-item class="text-center">
              <v-icon icon="mdi-plus" style="font-size: 84px;">
              </v-icon>
              <h6 class="text">STRUCTURE</h6>
            </v-card-item>
          </v-card>
        </v-col>
        <v-col cols="6" class="">
          <v-card class="d-flex align-center justify-center h-100" @click="$router.push('/mapping')">
            <v-card-item class="text-center">
              <v-icon icon="mdi-map" style="font-size: 84px;">
              </v-icon>
              <h6 class="text">MAPPING</h6>
              <h6>FBS STRUCTURE</h6>
            </v-card-item>
          </v-card>
        </v-col>
      </v-row>
    </v-box>
  </div>
</template>

<script>
export default {
  methods: {
    
  }
}
</script>

<style scoped>
.text {
  text-transform: uppercase;
  letter-spacing: 4px !important;
  margin-top: 20px;
  font-weight: 100;
}
</style>
